import * as _ from 'lodash';

export function parseQuery(search = '?'): { [key: string]: string } {
  const params = search.split('?');
  const formattedParams =
    params.length > 1
      ? _.chain(params[1])
          .split('&')
          .map(_.ary(_.partial(_.split, _, '='), 1))
          .fromPairs()
          .value()
      : {};

  return formattedParams as any;
}
